import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useFilmsPrograms = () => {
  const path = `${API_ENDPOINTS.FILMS}/programs`;
  const { t } = useTranslation(LOCALIZATION_PAGES.FILMS);
  const { showNotification } = useRoot();
  const [{ result: programs, loading, error }, getPrograms] = useApi(path);

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('film_programs_fetch_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  return [{ programs, loading, error }, getPrograms];
};

export default useFilmsPrograms;
